/* AMP3 Contact page form → Chatway (sections/amp3-contact-page.liquid, "Message form" = Form → Chatway;
   Worker amp3-contact, which uses Chatway's Visitor Message API, POST /api/v1/conversations, added 8 Oct 2026).
   Sends the message straight into Chatway as the customer, so replies from Chatway reach them.
   Shopify's own form emails hello@ from mailer@shopify.com, and Chatway then replies to Shopify.
   Anything that goes wrong (bot check can't load, Worker down, Chatway error) falls back to
   Shopify's form, so a message is never lost; it then shows in Chatway as "amp3 (Shopify)".
   ?a3cw=1 on the Contact page forces it on in this browser tab for testing (?a3cw=0 forgets it). */
(function () {
  'use strict';
  var TURNSTILE_SRC = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
  var turnstileLoading = null;

  function loadTurnstile() {
    if (window.turnstile) return Promise.resolve(window.turnstile);
    if (turnstileLoading) return turnstileLoading;
    turnstileLoading = new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = TURNSTILE_SRC; s.async = true; s.defer = true;
      s.onload = function () { window.turnstile ? resolve(window.turnstile) : reject(new Error('turnstile')); };
      s.onerror = function () { turnstileLoading = null; reject(new Error('turnstile')); };
      document.head.appendChild(s);
    });
    return turnstileLoading;
  }

  function testMode() {
    try {
      if (/[?&]a3cw=1(&|$)/.test(location.search)) sessionStorage.setItem('a3cw', '1');
      if (/[?&]a3cw=0(&|$)/.test(location.search)) sessionStorage.removeItem('a3cw');
      return sessionStorage.getItem('a3cw') === '1';
    } catch (e) {
      return /[?&]a3cw=1(&|$)/.test(location.search);
    }
  }

  function init() {
    var wrap = document.querySelector('[data-a3cw]');
    if (!wrap || !window.fetch || !window.Promise) return;
    var form = wrap.querySelector('form');
    var endpoint = wrap.getAttribute('data-a3cw-endpoint');
    var sitekey = wrap.getAttribute('data-a3cw-sitekey');
    var on = wrap.getAttribute('data-a3cw') === 'true' || testMode();
    if (!on || !form || !endpoint || !sitekey) return;

    var check = wrap.querySelector('[data-a3cw-check]');
    var submit = form.querySelector('[type="submit"]');
    var token = '';
    var widgetId = null;
    var ready = false;
    var sending = false;
    var fallback = false;

    loadTurnstile().then(function (ts) {
      widgetId = ts.render(check, {
        sitekey: sitekey,
        action: 'contact',
        theme: 'light',
        appearance: 'interaction-only',
        callback: function (t) { token = t; },
        'expired-callback': function () { token = ''; },
        'error-callback': function () { token = ''; }
      });
      ready = true;
    }).catch(function () { /* no bot check available: Shopify's form handles it as before */ });

    function statusBox(kind) {
      var box = form.querySelector('[data-a3cw-status]');
      if (!box) {
        box = document.createElement('div');
        box.setAttribute('data-a3cw-status', '');
        form.insertBefore(box, form.firstChild);
      }
      box.className = 'a3i-form-status a3i-form-status--' + kind;
      box.setAttribute('role', kind === 'error' ? 'alert' : 'status');
      box.hidden = false;
      return box;
    }

    function showError(message, field) {
      statusBox('error').textContent = message || 'Please check the form and try again.';
      var names = { name: 'contact[name]', email: 'contact[email]', order: 'contact[Order number]', message: 'contact[body]' };
      var input = field && names[field] && form.querySelector('[name="' + names[field] + '"]');
      if (input) { input.setAttribute('aria-invalid', 'true'); input.focus(); }
    }

    function done() {
      var box = statusBox('ok');
      box.textContent = 'Thank you for your message. The AMP3 team will be in touch.';
      Array.prototype.forEach.call(form.children, function (el) { if (el !== box) el.hidden = true; });
      box.setAttribute('tabindex', '-1');
      box.focus();
    }

    // Shopify's own form, exactly as before this script existed: requestSubmit() fires a normal submit
    // event, so Shopify's own spam check (hCaptcha, listening on the document) runs as usual.
    function native() {
      fallback = true;
      sending = false;
      if (submit) submit.disabled = false;
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else HTMLFormElement.prototype.submit.call(form);
    }

    function waitForToken(ms) {
      return new Promise(function (resolve) {
        var waited = 0;
        (function poll() {
          if (token || waited >= ms) return resolve(token);
          waited += 200;
          setTimeout(poll, 200);
        })();
      });
    }

    function send(t) {
      if (!t) return native();
      var fd = new FormData(form);
      var payload = {
        name: fd.get('contact[name]') || '',
        email: fd.get('contact[email]') || '',
        topic: fd.get('contact[Enquiry topic]') || '',
        order: fd.get('contact[Order number]') || '',
        message: fd.get('contact[body]') || '',
        website: fd.get('a3cw_website') || '',
        page: location.href,
        turnstileToken: t
      };
      var ctrl = window.AbortController ? new AbortController() : null;
      var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, 15000);
      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        credentials: 'omit',
        signal: ctrl ? ctrl.signal : undefined
      }).then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (data) { return { status: res.status, data: data }; });
      }).then(function (r) {
        clearTimeout(timer);
        if (r.status === 200 && r.data && r.data.ok) return done();
        if (r.status === 400 && r.data && r.data.error === 'invalid') {
          sending = false;
          if (submit) submit.disabled = false;
          token = '';
          if (window.turnstile && widgetId !== null) window.turnstile.reset(widgetId);
          return showError(r.data.message, r.data.field);
        }
        native();
      }).catch(function () {
        clearTimeout(timer);
        native();
      });
    }

    form.addEventListener('submit', function a3cwSubmit(e) {
      if (fallback || !ready) return; // Shopify's form
      e.preventDefault();
      // Stop Shopify's contact-form spam check from also handling this submit. It binds its own submit
      // listener to the form when a field is first focused (and one on the document), then sends the form to
      // Shopify a few seconds later, which gave a second, "amp3 (Shopify)" conversation (Joshua's test, 9 Oct 2026).
      // Ours is a capture listener added at page load, so it runs first and can stop the rest.
      e.stopImmediatePropagation();
      if (sending) return;
      sending = true;
      if (submit) submit.disabled = true;
      form.querySelectorAll('[aria-invalid]').forEach(function (n) { n.removeAttribute('aria-invalid'); });
      var old = form.querySelector('[data-a3cw-status]');
      if (old) old.hidden = true;
      waitForToken(8000).then(send);
    }, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
